/**
 * User roles available in the system that can be assigned service types.
 * This is a subset of backend roles allowed for service type assignment.
 */
export const UserRole = {
  HOUSEKEEPER: 'HOUSEKEEPER',
  HOUSEKEEPER_MANAGER: 'HOUSEKEEPER_MANAGER',
  INSPECTOR: 'INSPECTOR',
  MAINTENANCE: 'MAINTENANCE',
  PROPERTY_MANAGER: 'PROPERTY_MANAGER',
  ADMIN: 'ADMIN',
  CALL_CENTER: 'CALL_CENTER'
};

/**
 * Human-readable role labels for display
 */
export const UserRoleLabels = {
  [UserRole.HOUSEKEEPER]: 'Housekeeper',
  [UserRole.HOUSEKEEPER_MANAGER]: 'Housekeeper Manager',
  [UserRole.INSPECTOR]: 'Inspector',
  [UserRole.MAINTENANCE]: 'Maintenance',
  [UserRole.PROPERTY_MANAGER]: 'Property Manager',
  [UserRole.ADMIN]: 'Admin',
  [UserRole.CALL_CENTER]: 'Call Center',
  'GUEST_APP_MANAGER': 'Guest App Manager'
};

/**
 * Role keys that can be selected as "Visible To" when creating or editing notes.
 * Used by AddNoteModal and EditNoteModal so notes can be targeted to specific roles (e.g. Call Center only).
 */
export const NoteVisibilityRoleKeys = [
  UserRole.HOUSEKEEPER,
  UserRole.HOUSEKEEPER_MANAGER,
  UserRole.INSPECTOR,
  UserRole.MAINTENANCE,
  UserRole.PROPERTY_MANAGER,
  UserRole.CALL_CENTER,
  'GUEST_APP_MANAGER'
]; 